// src/pages/InspirationRepasPage.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Remplace next/router
//On importe PersonalizedForm pour l'utiliser dans la page
import SuggestionsList from '../components/SuggestionsList';
import { PreferenceCategory, IngredientsSelector } from '../components/utils/PersonalizedForm';
import api from '../api/api'; // Import de l'API configurée avec Axios
import RecipeDisplay from '../components/RecipeDisplay';
import Seo from '../components/Seo';

const InspirationRepasPage = () => {
  const navigate = useNavigate(); // Remplace useRouter
  const [isLoading, setIsLoading] = useState(false);
  const [imgVerified, setImgVerified] = useState(false);
  const [recipe, setRecipe] = useState(null);
  const [formData, setFormData] = useState({
    dish: [],
    preparationTime: 30,
    bakingTime: 30,
    cuisine: [],
    complexity: [],
    ingredients: [],
    description: ''
  });
  const [suggestions, setSuggestions] = useState(null);
  const [oldSuggestions, setOldSuggestions] = useState(null);

  React.useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const lastPageType = urlParams.get('lastPageType');
    if (lastPageType=== 'formInspiration') {
      // Récupérer les données du formulaire depuis le localStorage
      const lastFormData = JSON.parse(localStorage.getItem('lastFormData'));
      if (lastFormData) {
        setFormData(lastFormData);
        localStorage.removeItem('lastFormData'); // Nettoyer le localStorage après utilisation
      }

    }
    else if (lastPageType === 'suggestions') {
      // Récupérer les suggestions et paramètres depuis le localStorage
      const lastSuggestions = JSON.parse(localStorage.getItem('lastSuggestions'));
      const lastParameters = JSON.parse(localStorage.getItem('lastParameters'));
      if (lastSuggestions && lastParameters) {
        setSuggestions(lastSuggestions);
        setFormData(lastParameters);
        localStorage.removeItem('lastSuggestions'); // Nettoyer le localStorage après utilisation
        localStorage.removeItem('lastParameters'); // Nettoyer le localStorage après utilisation
      }
    }
      
  }, []);


React.useEffect(() => {
  console.log('boom')
  if (!suggestions || suggestions.length === 0 || imgVerified) {
    return;
  }

  const intervalId = setInterval(async () => {
    let updated = false;
    let allHaveImages = true;
    const updatedSuggestions = [...suggestions];

    for (let typeIndex = 0; typeIndex < suggestions.length; typeIndex++) {
      const suggestionBlock = suggestions[typeIndex];

      for (let suggIndex = 0; suggIndex < suggestionBlock.suggestions.length; suggIndex++) {
        const suggestion = suggestionBlock.suggestions[suggIndex];
        console.log(suggestion);
        // Skip if suggestion already has images
        if (suggestion.imgUrlArray && suggestion.imgUrlArray.length > 0) {
          continue;
        }

        try {
          const { data } = await api.get(`/api/meals/check-images/${suggestion._id}?type=suggestion`);
          console.log(data)
          if (data.success && data.data.images && data.data.images.length > 0) {
            updatedSuggestions[typeIndex].suggestions[suggIndex] = {
              ...suggestion,
              imgUrlArray: data.data.images,
            };
            updated = true;
          } else {
            allHaveImages = false;
          }
        } catch (err) {
          console.error(`Error for ${suggestion._id}:`, err);
          allHaveImages = false;
        }
      }
    }

    if (updated) {
      setSuggestions(updatedSuggestions); // Update state only if changes occurred
    }

    if (allHaveImages) {
      setImgVerified(true); // Set verified to stop future intervals
    }
  }, 5000);

  return () => clearInterval(intervalId); // Cleanup on unmount or dependency change
}, [suggestions, imgVerified]);

  // Données pour les PreferenceCategory
  const dishItems = [
    { name: 'Apéritif', img: './img/aperitive.png' },
    { name: 'Apéritif-dinatoire', img: './img/aperitive-diner.png' },
    { name: 'Cocktail', img: './img/cocktail.png' },
    { name: 'Soupe', img: './img/soup.png' },
    { name: 'Entrée', img: './img/entry.png' },
    { name: 'Plat chaud', img: './img/hot-dish.png' },
    { name: 'Plat froid', img: './img/cold-dish.png' },
    { name: 'Dessert', img: './img/dessert.png' },
    { name: 'Goûter', img: './img/snack.png' },
    { name: 'LunchBox', img: './img/lunchbox.png' }
  ];

  const cuisineItems = [
    { name: 'Française', img: './img/french.png' },
    { name: 'Italienne', img: './img/italian.png' },
    { name: 'Asiatique', img: './img/asian.png' },
    { name: 'Mexicaine', img: './img/mexican.png' },
    { name: 'Indienne', img: './img/indian.png' },
    { name: 'Méditerranéenne', img: './img/mediterranean.png' },
    { name: 'Américaine', img: './img/american.png' }
  ];

  const complexityItems = [
    { name: 'Facile', img: './img/easy.png' },
    { name: 'Moyenne', img: './img/medium.png' },
    { name: 'Difficile', img: './img/hard.png' }
  ];
  useEffect(() => {
    console.log('Form data updated:', formData);
  }, [formData]);
  const handlePreferenceToggle = (name, value) => {
    setOldSuggestions(null);
    //LES VIEILLES SUGGESTIONS N ONT PLUS LIEUX D ETRE
    setFormData(prev => ({
      ...prev,
      [name]: prev[name].includes(value) 
        ? prev[name].filter(item => item !== value)
        : [...prev[name], value]
    }));
  };

  // Add handler for recipe selection
const handleRecipeSelection = (selectedRecipe) => {
  setRecipe(selectedRecipe);
  setSuggestions(null);
};

  const handleIngredientsChange = (ingredients) => {
    setOldSuggestions(null);
    ;console.log('boom6')
    setFormData(prev => ({
      ...prev,
      ingredients
    }));
  };

  const generateSuggestions = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    
    try {
      //Récuperation de user dans localStorage
      const user = JSON.parse(localStorage.getItem('user'));
      console.log("User récupéré:", user);
      console.log(formData);
      if(oldSuggestions){
        setSuggestions(oldSuggestions);
      }
      else if(formData.dish.length === 0) {
        const response = await api.post('/api/meals/generate-recipe', {...formData, userId: user.id});
        console.log("Response from generate-recipe:", response.data);
        // Redirection vers la page de recette générée
        navigate(`/recette/${response.data.recipe.id}?lastPageType=formInspiration`);
      }
      else{
        setImgVerified(false);
        const response = await api.post('/api/meals/recipe-suggestions', {...formData, userId: user.id});
        setSuggestions(response.data.data.suggestions);
      }

    } catch (error) {
      console.error("Erreur:", error);
      if (!(error?.response && error.response.status === 429)) {
        alert("Une erreur est survenue lors de la génération de la recette.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Seo
        title="Inspiration de repas"
        description="Décrivez vos envies et laissez YAQAM générer des idées de repas personnalisées en quelques secondes."
        breadcrumb
      />
      <div className="max-w-4xl mx-auto px-4 py-8">
      {!suggestions? (
        <>
          <h1 className="text-3xl font-bold mb-6 text-center text-[#2C3E50]">Donnez vos envies, YAQAM vous donnes ses idées 🧠</h1>
          <div className="bg-white rounded-lg shadow-md mb-8 border border-gray-100">
            <h2 className="text-xl font-semibold mb-4 text-[#2C3E50]">Que voulez-vous manger aujourd'hui?</h2>
            
            <form onSubmit={generateSuggestions}>
              {/* Humeur */}
              <PreferenceCategory
                title="Quel type de plat souhaitez-vous manger"
                color="blue"
                items={dishItems}
                selectedItems={formData.dish}
                onToggle={handlePreferenceToggle}
                inputName="dish"
                placeholder="Autre plat..."
                cols={3}
              />

              {/* Temps de preparation disponible */}
              <div className="mb-4">
                <label className="block text-[#2C3E50] font-medium mb-2">
                  Temps de préparation maximum (minutes) par plat: {formData.preparationTime}
                </label>
                <input 
                  type="range" 
                  name="preparationTime"
                  min="10" 
                  max="120" 
                  step="5"
                  value={formData.preparationTime}
                  onChange={(e) => {setOldSuggestions(null);console.log('boom0');setFormData(prev => ({ ...prev, preparationTime: e.target.value }))}}
                  className="w-full accent-[#87A96B]"
                />
                <div className="flex justify-between text-xs text-gray-500">
                  <span>10 min</span>
                  <span>120 min et plus</span>
                </div>
              </div>

              {/* Temps de cuisson disponible */}
              <div className="mb-4">
                <label className="block text-[#2C3E50] font-medium mb-2">
                  Temps de cuisson maximum (minutes) par plat: {formData.bakingTime}
                </label>
                <input 
                  type="range" 
                  name="bakingTime"
                  min="0" 
                  max="120" 
                  step="6"
                  value={formData.bakingTime}
                  onChange={(e) => {setOldSuggestions(null);console.log('boom1');setFormData(prev => ({ ...prev, bakingTime: e.target.value }))}}
                  className="w-full accent-[#E67E22]"
                />
                <div className="flex justify-between text-xs text-gray-500">
                  <span>0 min</span>
                  <span>120 min et plus</span>
                </div>
              </div>

              {/* Type de cuisine */}
              <PreferenceCategory
                title="Type de cuisine"
                color="green"
                items={cuisineItems}
                selectedItems={formData.cuisine}
                onToggle={handlePreferenceToggle}
                inputName="cuisine"
                placeholder="Autre type de cuisine..."
                cols={3}
              />

              {/* Complexité */}
              <PreferenceCategory
                title="Niveau de difficulté"
                color="yellow"
                items={complexityItems}
                selectedItems={formData.complexity}
                onToggle={handlePreferenceToggle}
                inputName="complexity"
                cols={3}
                otherInput={false}
              />

              {/* Ingrédients */}
              <div className="mb-6">
                <label className="block text-[#2C3E50] font-medium mb-2">Ingrédients que vous souhaitez utiliser</label>
                <IngredientsSelector 
                  onChange={handleIngredientsChange}
                  ingredientsList={[]} // Ajoutez votre liste d'ingrédients ici
                  initialSelected={formData.ingredients}
                />
              </div>

              {/* Description des envies */}
              <div className="mb-6">
                <label className="block text-[#2C3E50] font-medium mb-2">Description de vos envies (facultatif)</label>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={(e) => {setOldSuggestions(null);console.log('boom2');setFormData(prev => ({ ...prev, description: e.target.value }))}}
                  placeholder="Décrivez ce dont vous avez envie..."
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#87A96B] focus:border-[#87A96B] transition-colors"
                  rows="3"
                />
              </div>

              <button
                type="submit"
                disabled={isLoading}
                className="w-full bg-[#87A96B] text-white py-3 rounded-md hover:bg-[#87A96B]/90 transition-colors flex items-center justify-center font-medium shadow-md hover:shadow-lg"
              >
                {isLoading ? (
                  <>
                    <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Génération en cours...
                  </>
                ) : "Générer une recette inspirante"}
              </button>
            </form>
          </div>
        </>
      ) : (
        <>
          <button
            onClick={() => { setOldSuggestions(suggestions);setSuggestions(null);}}
            className="mb-4 px-4 py-2 bg-[#2C3E50] text-white rounded hover:bg-[#2C3E50]/90 transition-colors font-medium"
          >
            ← Retour
          </button>
          <SuggestionsList 
            suggestions={suggestions} 
            parameters={formData}
            userId={JSON.parse(localStorage.getItem('user'))._id ? JSON.parse(localStorage.getItem('user'))._id : JSON.parse(localStorage.getItem('user')).id}
            onSelectRecipe={handleRecipeSelection}
          />
        </>
      )}
      </div>
    </>
  );
};

export default InspirationRepasPage;
